<template>
  <div>
    <div class="d-flex align-center mt-7">
      <v-icon class="mr-2" size="30" :color="$vuetify.theme.primary || '#39424e'" @click="$emit('back')">
        mdi-arrow-left-circle
      </v-icon>
      <span class="ml-3 navigation-title">
        Questionário de Avaliação de Risco
      </span>
    </div>

    <v-row class="mt-3 px-5">
      <v-col
        cols="12"
        style="
          padding: 0px !important;
          display: flex;
          align-items: center;
          justify-content: flex-start;
        "
        v-for="question in questions"
        :key="question.id_pergunta"
      >
        <v-col cols="12" sm="8" md="8" class="mb-5">
          <strong>{{ question.nm_pergunta }}</strong>
          <v-textarea
            rows="2"
            v-model="question.nm_justificativa"
            hide-details
            placeholder="Justificativa: "
            outlined
          ></v-textarea>
          <v-col
            cols="6"
            md="4"
            class="d-flex align-end mt-3 btn-mobile"
            style="
              margin: 0px !important;
              padding: 0px !important;
              margin-top: 10px;
            "
          >
            <v-btn
              @click="question.resposta = true"
              class="mr-3"
              :class="question.resposta ? 'active' : ''"
            >
              Sim
            </v-btn>
            <v-btn
              @click="question.resposta = false"
              :class="!question.resposta ? 'active' : ''"
            >
              Não
            </v-btn>
          </v-col>
        </v-col>
        <v-col cols="6" md="4" class="d-flex align-end mt-3 btn-desktop">
          <v-btn
            @click="question.resposta = true"
            class="mr-3"
            :class="question.resposta ? 'active' : ''"
          >
            Sim
          </v-btn>
          <v-btn
            @click="question.resposta = false"
            :class="!question.resposta ? 'active' : ''"
          >
            Não
          </v-btn>
        </v-col>
      </v-col>

      <v-col cols="12" class="d-flex justify-end mb-7">
        <v-btn
          :style="
            $vuetify.theme.primary
              ? `color: var(--custom-white-second-color) !important; background-color: ${$vuetify.theme.primary} !important;`
              : 'color: var(--custom-white-second-color) !important;'
          "
          class="primary-button"
          :loading="loading"
          @click="submit"
        >
          Prosseguir
          <v-icon class="ml-2">mdi-arrow-right-bold-circle-outline</v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import ApiService from "../../../../services/ApiService";
export default {
  name: "MedicalQuestions",
  data() {
    return {
      api: new ApiService(),
      loading: false,
      questions: [
        {
          id_pergunta: 11,
          id_resposta: 28,
          nr_questao: 1,
          nm_justificativa: "",
          resposta: false,
          nm_pergunta:
            "O proponente possui faturamento anual superior a R$ 5.000.000,00?",
        },
        {
          id_pergunta: 12,
          id_resposta: 30,
          nr_questao: 2,
          resposta: false,
          nm_justificativa: "",
          nm_pergunta:
            "O objetivo de contratação do seguro é em atendimento a um contrato específico?",
        },
        {
          id_pergunta: 21,
          id_resposta: 48,
          nr_questao: 11,
          resposta: false,
          nm_justificativa: "",
          nm_pergunta:
            "O Proponente realiza procedimentos puramente estéticos, que não seja de finalidade reparadora?",
        },
        {
          id_pergunta: 29,
          id_resposta: 65,
          nr_questao: 19,
          resposta: false,
          nm_justificativa: "",
          nm_pergunta:
            "O proponente tem conhecimento de qualquer fato que possa vir a resultar em reclamação de responsabilidade civil profissional?",
        },
        {
          id_pergunta: 36,
          id_resposta: 79,
          resposta: false,
          nr_questao: 26,
          nm_justificativa: "",
          nm_pergunta:
            "Nos últimos 5 anos, o proponente foi alvo de alguma reclamação por falha na prestação de serviços profissionais?",
        },
      ],
    };
  },
  created() {
    const styleElement = document.createElement("style");
    styleElement.textContent = `:root { 
      --custom-primary-color: ${ this.$vuetify.theme.primary || "#00C7BA" };
      --custom-white-color: ${
        this.$store.state.socio
          ? !this.isColorDark(this.$store.state.socio.cor)
            ? "#013"
            : "#fff"
          : "#00C7BA"
      };
      --custom-white-second-color: ${
        this.$store.state.socio
          ? !this.isColorDark(this.$store.state.socio.cor)
            ? "#013"
            : "#fff"
          : "#fff"
      };
     }`;
    document.head.appendChild(styleElement);
  },
  methods: {
    async submit() {
      this.loading = true;
      localStorage.removeItem("questions");
      localStorage.setItem("questions", JSON.stringify(this.questions));
      this.$emit("next", 2);
      this.loading = false;
    },
    isColorDark(color) {
      if (!color) {
        return false;
      }
      const luminosity = this.calculateLuminosity(color);
      return luminosity < 128;
    },
    isColorLight(color) {
      return !this.isColorDark(color);
    },
    calculateLuminosity(color) {
      const rgb = this.hexToRgb(color);
      const luminosity = 0.299 * rgb.r + 0.587 * rgb.g + 0.114 * rgb.b;
      return luminosity * 255;
    },
    hexToRgb(hex) {
      const bigint = parseInt(hex.replace("#", ""), 16);
      const r = (bigint >> 16) & 255;
      const g = (bigint >> 8) & 255;
      const b = bigint & 255;
      return {
        r: r / 255,
        g: g / 255,
        b: b / 255,
      };
    },
  },
};
</script>

<style scoped>
.active {
  background-color: var(--custom-primary-color) !important;
  color: var(--custom-white-second-color) !important;
}

@media (max-width: 600px) {
  .btn-mobile {
    display: flex !important;
  }

  .btn-desktop {
    display: none !important;
  }
}

@media (min-width: 600px) {
  .btn-mobile {
    display: none !important;
  }

  .btn-desktop {
    display: flex !important;
  }
}
</style>
